<div class="container-xxl">
    <div class="fs-14 mb-5 ls-1 fw-700 text-uppercase font-secondary text-center">
        {{ 'PARTNER_SALONS.voivodeship' | translate: { voivodeship } }}
    </div>

    <div class="text-end mb-4">
        <a class="btn btn-outline btn-primary justify-content-between align-items-center" [routerLink]="['..']">
            <img src="/assets/images/icons/arrow-right.svg" class="arrow-icon me-4" alt="" />
            <span>{{ 'BUTTONS.back' | translate }}</span>
        </a>
    </div>

    <div class="mb-4">
        @for (partnersUnique of partnersUnique$ | async; track partnersUnique.name) {
            <app-item [partnersUnique]="partnersUnique" />
        }
    </div>
</div>
